import React, { useCallback, useRef, useState } from 'react';
import { ArrowForward } from '@yme/assets/icons';
import { Button, GHOST_VARIANT, LEADING_ICON, SIZE_44 } from '@yme/atoms/button';
import { SVGIcon } from '@yme/atoms/svg-icon';
import { buildAccordionData } from '@yme/components/FAQContent/helpers';
import { STICKY_HEADER_HEIGHT_DEFAULT } from '@yme/components/Header/constants';
import { useWindowSize } from '@yme/hooks/index';
import { FAQSection } from '@yme/molecules/faq-section';
import { colorCoreBlack300, colorCoreBlack900Base, colorCoreWhite1000 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { HeadingLevel2, HeadingLevel3, RegularTextLevel3, RegularTextLevel4, } from '@yme/tokens/typography';
import { buildStateParam } from '@yme/utils/common';
import { OFFSET_FOR_STICKY_HEADER, OFFSET_VERTICAL } from './constants';
import { TopicsListItemStyled, TopicsListStyled } from './styled';
export function TopicComponent({ headerLabel, description, sections, activeItem, setActiveItem, isRightToLeft, backToTopicsLabel, }) {
    const [mobileSectionName, setMobileSectionName] = useState('');
    const wrapperRef = useRef(null);
    const { isInfiniteDesktopView } = useWindowSize();
    const sectionData = sections.find((section) => mobileSectionName === section.title);
    const handleDesktopItemClick = (event) => {
        const { target } = event.currentTarget.dataset;
        if (target) {
            const article = document.getElementById(target);
            if (article) {
                const y = window.scrollY <= OFFSET_FOR_STICKY_HEADER
                    ? article.getBoundingClientRect().top + OFFSET_VERTICAL - STICKY_HEADER_HEIGHT_DEFAULT
                    : article.getBoundingClientRect().top + OFFSET_VERTICAL + window.scrollY;
                window.scrollTo({
                    top: y,
                    behavior: 'smooth',
                });
                setActiveItem(target);
            }
        }
    };
    const handleMobileItemClick = (event) => {
        const { target } = event.currentTarget.dataset;
        setMobileSectionName(target || '');
    };
    const handleReturnClick = useCallback(() => {
        setMobileSectionName('');
        const wrapperElement = wrapperRef.current;
        if (wrapperElement) {
            const yOffset = -STICKY_HEADER_HEIGHT_DEFAULT;
            const y = wrapperElement.getBoundingClientRect().top + window.scrollY + yOffset;
            window.scrollTo({
                top: y,
                behavior: 'smooth',
            });
        }
    }, []);
    const listItems = sections.map((section) => {
        const isActive = activeItem === section.title;
        const textColor = isActive ? colorCoreBlack900Base : colorCoreBlack300;
        return (React.createElement(TopicsListItemStyled, { onClick: isInfiniteDesktopView ? handleDesktopItemClick : handleMobileItemClick, "data-target": section.title, isActive: isActive, key: buildStateParam() }, isInfiniteDesktopView ? (React.createElement(RegularTextLevel4, { color: textColor, weight: 500 }, section.title)) : (React.createElement(FlexWrapper, { justifyContent: "space-between", alignItems: "center" },
            React.createElement(RegularTextLevel3, { weight: 500 }, section.title),
            React.createElement(SVGIcon, { type: ArrowForward })))));
    });
    return (React.createElement(FlexWrapper, { bg: colorCoreWhite1000, flexDirection: "column", paddingDesktop: "48px", paddingTablet: "24px", paddingMobile: "16px", gap: isInfiniteDesktopView ? '32px' : '24px', ref: wrapperRef },
        React.createElement(FlexWrapper, { flexDirection: "column", gap: "8px" },
            isInfiniteDesktopView && React.createElement(HeadingLevel3, null, headerLabel),
            !isInfiniteDesktopView && !mobileSectionName && (React.createElement(HeadingLevel2, null, headerLabel)),
            !mobileSectionName && (React.createElement(RegularTextLevel3, { color: colorCoreBlack300 }, description))),
        !isInfiniteDesktopView && mobileSectionName ? (React.createElement(FlexWrapper, { flexDirection: "column", gap: "24px" },
            React.createElement(FAQSection, { title: sectionData?.title || '', isRightToLeft: isRightToLeft, accordionData: buildAccordionData(sectionData?.items, isRightToLeft) }),
            React.createElement(Button, { buttonVariant: GHOST_VARIANT, hasIconButton: LEADING_ICON, iconComponent: ArrowForward, size: SIZE_44, iconRotate: isRightToLeft ? 0 : 180, label: backToTopicsLabel, onClick: handleReturnClick }))) : (React.createElement(TopicsListStyled, null, listItems))));
}
